export function LoadingState() {
  return (
    <div className="flex flex-col items-center justify-center py-16" role="status" aria-live="polite">
      <div className="w-8 h-8 border-2 border-slate-200 border-t-emerald-600 rounded-full animate-spin mb-3" aria-hidden="true" />
      <p className="text-sm text-slate-500">Loading...</p>
    </div>
  );
}